module.exports = __webpack_public_path__ + "static/media/Path copyagain.8e559e93.png";